import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const ShareButton = ({ sharePath, title, testid = "share-btn" }) => {
  const share = async () => {
    const url = `${window.location.origin}/api/share/${sharePath}`;
    if (navigator.share) {
      try { await navigator.share({ title, url }); return; } catch (e) { if (e.name === "AbortError") return; }
    }
    await navigator.clipboard.writeText(url);
    toast.success("Link di condivisione copiato! Incollalo su Instagram, Facebook o WhatsApp.");
  };
  return (
    <button onClick={share} data-testid={testid}
      className="inline-flex items-center gap-2 rounded-full border border-white/15 px-5 py-2.5 font-mono-tga text-xs uppercase tracking-[0.15em] text-zinc-300 hover:border-emerald-500/60 hover:text-emerald-300 transition-colors">
      <Share2 className="h-4 w-4" /> Condividi
    </button>
  );
};
